import { render, staticRenderFns } from "./OurFacilitiesItem.vue?vue&type=template&id=030138bc&scoped=true&"
import script from "./OurFacilitiesItem.vue?vue&type=script&lang=js&"
export * from "./OurFacilitiesItem.vue?vue&type=script&lang=js&"
import style0 from "./OurFacilitiesItem.vue?vue&type=style&index=0&id=030138bc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "030138bc",
  null
  
)

export default component.exports